import { Link } from "react-router-dom";

import { PageShell } from "../components/PageShell.js";
import { Seo } from "../components/Seo.js";

export function Home() {
  return (
    <PageShell
      variant="home"
      actions={
        <div className="cta-row cta-row-center">
          <Link to="/about" className="primary-button">
            Explore JivaSeva
          </Link>
          <Link to="/app" className="secondary-button">
            Discover Our Services
          </Link>
        </div>
      }
    >
      <Seo
        title="JivaSeva · Life Takes Care of Life"
        description="JivaSeva is an independent, volunteer-driven, not-for-profit initiative founded on the principle that Life Takes Care of Life."
        path="/"
      />
      <div className="brand-mark">
        <span className="brand-mark-name">JivaSeva</span>
        <span className="brand-mark-tagline">Life Takes Care of Life</span>
      </div>

      <p className="manifesto">
        <span className="brand-name">JivaSeva</span> is founded on the understanding that all life, though seemingly separate, is an expression of a single underlying reality.
      </p>
      <p className="manifesto">
        From this understanding arises the conviction that the well-being of each depends upon the well-being of all, and that the world's resources are to be shared responsibly and compassionately so that all beings may flourish.{" "} This is the spirit of
        <span className="brand-name"> Life taking care of Life</span>.
      </p>
      <p className="manifesto">
        To this end, <span className="brand-name">JivaSeva</span> provides the tools, resources, and opportunities that empower and nurture this natural impulse toward selfless service.
      </p>
    </PageShell>
  );
}
